import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Coffee, ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

export const BrunchBanner = () => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/menus/brunch/today").then(({ data }) => data.active && setInfo(data)).catch(() => {});
  }, []);

  if (!info) return null;
  const title = info.label ? `${info.label} Today` : "Brunch Today";

  return (
    <Link
      to="/menu?tab=brunch"
      data-testid="brunch-today-banner"
      className="group max-w-6xl w-full mx-auto mt-6 flex items-center gap-4 bg-[var(--trio-accent)] text-[var(--trio-text)] px-5 py-4 border-2 border-[var(--trio-text)] hover:bg-[var(--trio-primary)] hover:text-white transition-colors"
    >
      <span className="relative flex w-10 h-10 shrink-0 items-center justify-center bg-[var(--trio-text)] text-[var(--trio-accent)]">
        <Coffee className="w-5 h-5" />
        {info.live && <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-[var(--trio-primary)] animate-pulse" />}
      </span>
      <span className="flex-1 min-w-0">
        <span data-testid="brunch-today-title" className="block font-display uppercase text-xl sm:text-2xl tracking-tight leading-none">
          {title}{info.live ? " · Now Serving" : ""}
        </span>
        <span data-testid="brunch-today-hours" className="block text-xs sm:text-sm tracking-widest uppercase mt-1 opacity-80">
          {info.hours} · Walk-ins welcome
        </span>
      </span>
      <ArrowUpRight className="w-5 h-5 shrink-0 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </Link>
  );
};
